import { Image, Tag, Tooltip } from '@chakra-ui/react';
import MaterialTable from 'material-table';
import React from 'react';
import { useSelector } from 'react-redux';

import { CustomTableToolbar } from 'components/index';
import { components, tableIcons } from 'components/v4/MaterialTable/consts';

import { classNames as clx } from 'utils/classNames';
import { convertDateFormat } from './helper';

import msTeamsLogo from 'assets/images/ms_teams_logo.png';
import sbcLogo from 'assets/images/SbcaasLogo.png';
import webexLogo from 'assets/images/webex.png';
import zoomLogo from 'assets/images/zoom.svg';

import dummyData from '../dummyData';
import { MATERIAL_TABLE_OPTIONS, statusClasses } from './constants';
import ExportCSVButton from './ExportCSVButton';

export default function UsersAuditTable() {
    const tableRef = React.useRef(null);
    const { darkMode } = useSelector((state) => state.settings);
    const statusRender = (status) => {
        switch (status) {
            case 'PendingUpload':
                return (
                    <Tag className={clx(statusClasses['Pending'], 'w-36')}>
                        Pending Upload
                    </Tag>
                );

            case 'Error':
                return (
                    <Tag className={clx(statusClasses['Suspended'], 'w-36')}>
                        Error
                    </Tag>
                );

            case 'Updating':
                return (
                    <Tag className={clx(statusClasses['Ready'], 'w-36')}>
                        Updating
                    </Tag>
                );

            case 'ActionRequired':
                return (
                    <Tag className={clx(statusClasses['Pending'], 'w-36')}>
                        Action Required
                    </Tag>
                );

            case 'OK':
                return (
                    <Tag className={clx(statusClasses['Active'], 'w-36')}>
                        Ok
                    </Tag>
                );

            case 'PendingRemoval':
                return (
                    <Tag className={clx(statusClasses['Inactive'], 'w-36')}>
                        Pending Removal
                    </Tag>
                );

            default:
                return null;
        }
    };

    const renderLogo = (rowData) => {
        switch (rowData.PlatformID?.toLowerCase()) {
            case 'zoom':
                return zoomLogo;
            case 'webex':
                return webexLogo;
            case 'teams':
                return msTeamsLogo;
            case 'sip trunk':
                return sbcLogo;
            default:
                return null;
        }
    };
    const defaultColumns = [
        {
            title: 'Platform ID',
            field: 'PlatformID',
            width: '10%',
            render: (rowData) => (
                <Tooltip hasArrow label={rowData.PlatformID}>
                    <Image
                        boxSize={5}
                        objectFit="contain"
                        alt={rowData.platformID}
                        src={renderLogo(rowData)}
                    />
                </Tooltip>
            ),
        },
        {
            title: 'Number ID',
            field: 'NumberID',
        },
        {
            title: 'User ID',
            field: 'UserID',
        },
        {
            title: 'User Status',
            field: 'UserStatus',
            render: (rowData) => statusRender(rowData['UserStatus']),
        },
        {
            title: 'Timestamp',
            field: 'DateTime',
            render: (rowData) => convertDateFormat(rowData['DateTime']),
        },
        {
            title: 'Admin ID',
            field: 'AdminUserID',
        },
    ];

    const exportCsvOptions = {
        columns: defaultColumns,
        data: dummyData.userHistory,
        exportCsv: tableRef?.current?.props?.options?.exportCsv,
        titleName: 'Users Audit',
    };
    return (
        <MaterialTable
            icons={tableIcons}
            tableRef={tableRef}
            columns={defaultColumns}
            data={dummyData.userHistory}
            options={{
                ...MATERIAL_TABLE_OPTIONS,
                headerStyle: {
                    position: 'sticky',
                    top: 0,
                    background: darkMode ? '#121212' : 'white',
                },
            }}
            components={{
                ...components,
                Toolbar: (props) => {
                    return (
                        <CustomTableToolbar
                            {...props}
                            resetColumnsButton={false}
                        />
                    );
                },
            }}
            title={<ExportCSVButton options={exportCsvOptions} />}
        />
    );
}
